/**
 * Atalhos de teclado do portal. Antes eram Ctrl/Cmd+1…9, Ctrl+Tab e Ctrl/Cmd+W, que o navegador reserva (no Mac o
 * Cmd+W fechava a aba do Chrome, não a do portal) e que não apareciam em lugar nenhum. Agora usam Alt (⌥ no Mac),
 * que o navegador não usa, e são listados no Ctrl K e nas dicas (28/10/2026).
 */
export const ehMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);

const ALT = ehMac ? '⌥' : 'Alt+';
const CTRL = ehMac ? '⌘' : 'Ctrl+';

export const ATALHOS = {
  buscar: `${CTRL}K`,
  irParaAba: `${ALT}1…9`,
  trocarAba: `${ALT}← / ${ALT}→`,
  fecharAba: `${ALT}W`,
};

export const LISTA_ATALHOS: { teclas: string; acao: string }[] = [
  { teclas: ATALHOS.buscar, acao: 'buscar tela ou empresa' },
  { teclas: ATALHOS.irParaAba, acao: 'ir para a aba' },
  { teclas: ATALHOS.trocarAba, acao: 'aba anterior / próxima' },
  { teclas: ATALHOS.fecharAba, acao: 'fechar a aba' },
];

/** Foco num campo de texto: Alt+setas move por palavra, então os atalhos de troca de aba não valem ali. */
export const editandoTexto = (alvo: EventTarget | null) => {
  const el = alvo as HTMLElement | null;
  if (!el) return false;
  return el.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName);
};
